import { useQuery } from "react-query";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import NetworkImageWithLink from "../../components/image/NetworkImageWithLink";
import ProductService from "../../services/productService";
import { SwiperArrows } from "./components/SwiperArrows";

export const HomeBotBanner: FcDiv = ({ className }) => {
  const { data } = useQuery({
    queryFn: async () => {
      return await ProductService.getBanner({
        type: "HOME_TOP,HOME_BOTTOM",
      });
    },
  });
  if (!data?.botBanner?.length) return null;
  return (
    <div className={className + " swiper-no-navx banner relative"}>
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={8}
        slidesPerView={1}
        pagination={true}
        autoplay={{ delay: 4000 }}
        loop={true}
        navigation={{
          nextEl: "#botbanner-banner-next",
          prevEl: "#botbanner-banner-prev",
        }}
      >
        {(data.botBanner ?? []).map((m: BannerDTO) => (
          <SwiperSlide key={m.id}>
            <NetworkImageWithLink {...m} className="!h-[15rem]" />
          </SwiperSlide>
        ))}
      </Swiper>
      <SwiperArrows prefix="botbanner" />
    </div>
  );
};
